import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as notificationService from '../../services/notificationService';
import authActionConstants from '../constants/authActionConstants';
import globalActionConstants from '../constants/globalActionConstants';
import notificationActionConstants from '../constants/notificationActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getNotificationSettings = (userId) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await notificationService.getNotificationSettings(userId);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });

    if (response.data.response_code === responseCodes.OK) {
      const {
        payload: {
          user_preferences: { action, opted_out_notifications },
        },
      } = response.data;

      dispatch({
        type: notificationActionConstants.GET_NOTIFICATION_SETTINGS,
        payload: action,
      });
      dispatch({
        type: notificationActionConstants.GET_OPT_OUT_SETTINGS,
        payload: opted_out_notifications,
      });
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const getNotificationsList =
  (params = {}) =>
  async (dispatch) => {
    dispatch({
      type: notificationActionConstants.GET_NOTIFICATIONS_LIST,
      payload: {
        isPagination: Boolean(params.offset),
      },
    });

    try {
      const response = await notificationService.getNotificationsList(params);

      if (response.data.response_code === responseCodes.OK) {
        const {
          payload: { is_any_org_admin, notifications, unread_notifications },
        } = response.data;

        dispatch({
          type: authActionConstants.SET_ANY_ORG_ADMIN,
          payload: is_any_org_admin,
        });

        dispatch({
          type: notificationActionConstants.GET_NOTIFICATIONS_LIST_SUCCESS,
          payload: {
            notifications,
            unreadNotifications: unread_notifications,
            isPagination: Boolean(params.offset),
          },
        });
      } else {
        Notification.error(response.data.error);
      }
    } catch (err) {
      dispatch({ type: notificationActionConstants.GET_NOTIFICATIONS_LIST_ERROR });
      Notification.error(t('notifications.somethingWentWrong'));
    }
  };

export const updateNotificationsList = () => async (dispatch) => {
  dispatch({ type: notificationActionConstants.SET_READ_ALL });
  try {
    const response = await notificationService.updateNotification('mark_all');
    if (response.data.response_code === responseCodes.OK) {
      dispatch({
        type: notificationActionConstants.SET_READ_ALL_SUCCESS,
        payload: {
          unreadNotifications: response.data.payload.unread_notifications,
        },
      });
    } else {
      dispatch({
        type: notificationActionConstants.SET_READ_ALL_ERROR,
        payload: response.data.error,
      });
      Notification.error(response.data.error);
    }
  } catch (error) {
    dispatch({
      type: notificationActionConstants.SET_READ_ALL_ERROR,
      payload: error.message,
    });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const updateNotification = (id) => async (dispatch) => {
  dispatch({ type: notificationActionConstants.SET_READ });
  try {
    const response = await notificationService.updateNotification(id);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({
        type: notificationActionConstants.SET_READ_SUCCESS,
        payload: {
          unreadNotifications: response.data.payload.unread_notifications,
          notification: response.data.payload.notification[0],
        },
      });
    } else {
      dispatch({
        type: notificationActionConstants.SET_READ_ERROR,
        payload: response.data.error,
      });
      Notification.error(response.data.error);
    }
  } catch (error) {
    dispatch({
      type: notificationActionConstants.SET_READ_ERROR,
      payload: error.message,
    });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const updateNotificationSettings = (userId, obj) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  try {
    const response = await notificationService.updateNotificationSettings(userId, obj);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      const {
        payload: {
          user_preferences: { action },
        },
      } = response.data;

      dispatch({
        type: notificationActionConstants.UPDATE_NOTIFICATION_SETTINGS,
        payload: action,
      });
      Notification.success(t('notifications.notificationSettingsUpdated'));
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};
